import { Theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      maxWidth: 1280,
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      margin: '0 auto',
      padding: theme.spacing(25, 4),
      backgroundColor: theme.palette.background.default,
    },
    title: {
      marginBottom: theme.spacing(3.5),
      padding: theme.spacing(0, 3),
      textAlign: 'center',
    },
    input: {
      maxWidth: 480,
      width: '100%',
      marginBottom: theme.spacing(8),
    },
  })
);
